export default __webpack_public_path__ + "static/media/manali4.11857af4.webp";